module.exports = __webpack_public_path__ + "static/assets/40ca532104bc6d54c6c1e872ba571cfd.png";